if (!customElements.get('vbb-hero-media')) {
  class VbbHeroMedia extends HTMLElement {
    constructor() {
      super();
      this.animation = this.dataset.animation;
      this.media = Array.from(this.querySelectorAll('img, video'));
      this.activeMedia = this.media.find(media => media.tagName === 'IMG' && window.getComputedStyle(media.parentElement).display !== 'none');
      this.activeVideoMedia = this.media.find(media => media.tagName === 'VIDEO' && window.getComputedStyle(media.parentElement).display !== 'none');
      this.container = this.closest('section');
      // this.link = this.dataset.link || '';
      // if(this.link) {
      //   this.addEventListener('click', () => {
      //     window.location.href = this.link;
      //   });
      // }
    }

    applyParallax() {
      const scrolled = this.getBoundingClientRect().bottom - window.scrollY;
      const background = this.querySelector('img');
      background.style.transform = `translate3d(0, -${scrolled * (this.dataset.parallaxStrength / 100 ?? 0.5)}px, 0)`;
    }

    connectedCallback() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.animation == 'parallax' && this.activeMedia && !prefersReducedMotion) {
        const handleIntersection = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', () => {
                this.applyParallax();
              }, { passive: true });
            }
          });
        };

        const observer = new IntersectionObserver(handleIntersection, {
          root: null,
          threshold: 0.75
        });

        observer.observe(this.activeMedia);
      }
    }
  }

  customElements.define('vbb-hero-media', VbbHeroMedia);
}

// WIP Do not remove

// if (!customElements.get('vbb-hero-media')) {
//   class VbbHeroMedia extends HTMLElement {
//     constructor() {
//       super();
//       this.animation = this.dataset.animation;
//       this.media = Array.from(this.querySelectorAll('img, video'));
//       this.activeMedia = this.media.find(media => media.tagName === 'IMG' && window.getComputedStyle(media.parentElement).display !== 'none');
//       this.activeVideoMedia = this.media.find(media => media.tagName === 'VIDEO' && window.getComputedStyle(media.parentElement).display !== 'none');
//       this.container = this.closest('section');
//     }

//     applyParallax() {
//       const scrolled = this.getBoundingClientRect().bottom - window.scrollY;
//       const background = this.querySelector('img');
//       background.style.transform = `translate3d(0, -${scrolled * (this.dataset.parallaxStrength / 100 ?? 0.5)}px, 0)`;
//     }

//     connectedCallback() {
//       const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//       if (this.animation && !prefersReducedMotion) {
//         const handleIntersection = (entries, observer) => {
//           entries.forEach(entry => {
//             if (entry.isIntersecting) {
//               const bound = document.querySelector(`#${this.closest('section').id}`);
//               const video = this.activeVideoMedia;
//               let previousTime = 0;

//               const updateFrame = () => {
//                 if (video.duration) {
//                   const distanceFromTop = window.scrollY + bound.getBoundingClientRect().top;
//                   const rawPercentScrolled = (window.scrollY - distanceFromTop) / (bound.scrollHeight - window.innerHeight);
//                   const percentScrolled = parseFloat(Math.min(Math.max(rawPercentScrolled, 0), 1).toFixed(3));
//                   const time = parseFloat((video.duration * percentScrolled).toFixed(2));
//                   if (percentScrolled < 1 && previousTime != time) {
//                     console.log(time, percentScrolled, previousTime);
//                     video.currentTime = time;
//                     previousTime = time;
//                   }
//                 }
//                 // Request the next frame update
//                 requestAnimationFrame(updateFrame);
//               };

//               // Start the frame update loop
//               updateFrame();
//             }
//           });
//         };

//         const observer = new IntersectionObserver(handleIntersection, {
//           root: null,
//         });

//         observer.observe(this.activeVideoMedia.closest('section'));
//       }
//     }
//   }

//   customElements.define('vbb-hero-media', VbbHeroMedia);
// }
